var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('main.access_to_page_is_denied')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }